"use client";

import React from "react";
import { useSelector } from "react-redux";

import NotificationBanner from "@/components/Common/GlobalNotifications/NotificationBanner";
import useAppDispatch from "@/app/hooks/useAppDispatch";
import { hideAlert } from "@/store/alertsSlice";
import { getMinutesFromDate } from "@/lib/utils/date-time/utils";
import {getPersistentData, LS_NAMES, LS_VALUE, setExpiringPersistentData} from "@/lib/utils/local-storage";
import { RootState } from "@/store";
import { GlobalNotificationDTO } from "@/types/GlobalNotificationDTO";

// Helper function to get persistent data
const isAlertHidden = (id: number) => {
  const isHidden = getPersistentData(LS_NAMES.HIDDEN_ALERT, id) === LS_VALUE.HIDDEN;
  return isHidden;
}

const GlobalNotifications: React.FC = () => {
  const dispatch = useAppDispatch();
  const alertsData = useSelector((state: RootState) => state.alerts);
  // Helper function to determine if a notification should be shown
  const shouldShowNotification = (alert: any): boolean => {
    const { id, visible } = alert;
    if (!visible || !alertsData.alertData.length) return false;
    if (isAlertHidden(id)) return false; // Check if the alert is hidden
    return true;
  };

  // Helper function to handle closing a notification
  const handleClose = (id: string | number, end: string): void => {
    const minsFromEnd = getMinutesFromDate(end);
    const minsInDay = 24 * 60;
    const minsExpiration = Math.min(minsFromEnd, minsInDay);
    setExpiringPersistentData(LS_NAMES.HIDDEN_ALERT, LS_VALUE.HIDDEN, id, minsExpiration);
    dispatch(hideAlert(id));
  };

  return (
    <>
      {alertsData.alertData.map((alert: GlobalNotificationDTO) => {
        if (!shouldShowNotification(alert)) return null;

        return (
          <NotificationBanner
            key={alert.id}
            alert={alert}
            onClose={handleClose}
          />
        );
      })}
    </>
  );
};

export default GlobalNotifications;


